// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let MediaCard = require("../../common/Components/MediaCard.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let DevelopmentUnitSearchResultCard_newDevelopmentSampleUnit_graphql = require("../../../__generated__/DevelopmentUnitSearchResultCard_newDevelopmentSampleUnit_graphql.bs.js");

let getConnectionNodes = DevelopmentUnitSearchResultCard_newDevelopmentSampleUnit_graphql.Utils.getConnectionNodes;

let convertFragment = DevelopmentUnitSearchResultCard_newDevelopmentSampleUnit_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DevelopmentUnitSearchResultCard_newDevelopmentSampleUnit_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DevelopmentUnitSearchResultCard_newDevelopmentSampleUnit_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, DevelopmentUnitSearchResultCard_newDevelopmentSampleUnit_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DevelopmentUnitSearchResultCard_newDevelopmentSampleUnit_graphql.node, convertFragment, fRef);
}

let UnitFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DevelopmentUnitSearchResultCard(props) {
  let unit = RescriptRelay_Fragment.useFragment(DevelopmentUnitSearchResultCard_newDevelopmentSampleUnit_graphql.node, convertFragment, props.unit);
  let image = getConnectionNodes(unit.unitImages)[0];
  return JsxRuntime.jsx(MediaCard.make, {
    topLeftLabels: props.label,
    mediaLink: `/developments/` + unit.development.id + `/units/` + unit.id,
    media: image !== undefined ? ({
        TAG: "Image",
        _0: {
          src: image.url,
          width: 648,
          height: 468,
          alt: ""
        }
      }) : ({
        TAG: "Icon",
        _0: "home"
      }),
    children: props.children
  });
}

let make = DevelopmentUnitSearchResultCard;

exports.UnitFragment = UnitFragment;
exports.make = make;
/* MediaCard Not a pure module */
